/** Merge the current query string onto an internal path. Destination params win. */
export function withCurrentSearch(path: string): string {
  const dest = new URL(path, window.location.origin);
  const incoming = new URLSearchParams(window.location.search);
  incoming.forEach((value, key) => {
    if (!dest.searchParams.has(key)) dest.searchParams.set(key, value);
  });
  return dest.pathname + dest.search + dest.hash;
}
